import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-import-modal',
  templateUrl: './import-modal.component.html',
  styleUrls: ['./import-modal.component.css'],
  standalone: false
})

export class ImportModalComponent implements OnInit {
  
  GetFileUpload: any;
  @Output() saveEmit = new EventEmitter<string>();
  @Output() uploadEmit = new EventEmitter<string>();
  @Input('title') public title: string | string[] = '';
  @Input('idModal') public idmodal: string | string[] = '';

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
  }

  uploadFile(event: any) {
    this.uploadEmit.emit(event)
  }

  saveFile() {
    this.saveEmit.emit()
  }

}
